import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useContent } from "../lib/content";

export default function TestimonialsSection({ featuredOnly = false }) {
  const { t } = useContent();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/testimonials", { params: { featured_only: featuredOnly, limit: featuredOnly ? 12 : 50 } })
      .then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [featuredOnly]);

  // Hide the section completely until the first testimonial is published —
  // an empty section feels worse than no section. The owner can re-enable
  // by publishing one from the admin.
  if (items === null) return null;
  if (items.length === 0) return null;

  return (
    <section
      data-testid="testimonials-section"
      className="relative max-w-7xl mx-auto px-6 py-32 border-t border-white/5"
    >
      <div className="mb-16 max-w-2xl">
        <p className="overline mb-4">{t("testimonials_overline")}</p>
        <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-white">
          {t("testimonials_title")}
        </h2>
        <p className="mt-4 text-zinc-400 max-w-xl leading-relaxed">{t("testimonials_subtitle")}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((it) => (
          <TestimonialCard key={it.id} item={it} />
        ))}
      </div>
    </section>
  );
}

function TestimonialCard({ item }) {
  const stars = item.rating ? "✦".repeat(item.rating) : "";
  return (
    <div data-testid={`testimonial-${item.id}`}
      className={`card !p-7 flex flex-col ${item.featured ? "!border-[#C9A25E]/60 shadow-[0_0_30px_rgba(201,162,94,0.12)]" : ""}`}>
      {item.featured && <span data-testid={`testimonial-featured-${item.id}`} className="overline mb-3 !text-[#C9A25E]">✦ Destacado</span>}
      <span className="text-[#C9A25E] text-3xl font-display leading-none mb-2 opacity-50">“</span>
      <p className="text-zinc-200 leading-relaxed text-sm whitespace-pre-wrap flex-1">{item.message}</p>
      <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between gap-3">
        <p className="text-sm text-white font-display">{item.name || "Anónimo"}</p>
        {stars && <p className="text-[#C9A25E] text-xs tracking-widest">{stars}</p>}
      </div>
    </div>
  );
}
